import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, Row, Col } from "react-bootstrap";
import { DEVELOPMENT_TYPE, screenHeightLeftFromTop } from "Constants";
import { fetchTemplate } from "SettingActions";
import { fetchFeature } from "GeneralTabAction";
import LocaleStrings from "Languages";

import SMTP from "./smtp-setting";
import TestEmail from "./test-emailtemplate";
import WelcomeTemplateForm from "./welcomeTemplateForm";
import WelcomeWaitlistTemplate from "./welcome-with-waitlist";
import UserWaitlistConfirmedTemplate from "./user-waitlist-confirmed";
import SupportReplyTemplate from "./support-reply";
import UserScanExportTemplate from "./user-scan-export";
import TicketTemplateForm from "./ticketTemplateForm";
import OpenRegTicketTemplateForm from "./openRegTemplateForm";
import PurchaseTemplateForm from "./purchaseTemplateForm";
import PurchaseTemplateOfflineForm from "./purchaseTemplateOfflineForm";
import UserRegistration from "./user-registration";
import CourseOrder from "./course-order";
import SessionOrder from "./session-order";
import SubscriptionOrder from "./subscription-order";
import ResetPassword from "./reset-password";
import PushEmailtemplateForm from "./pushemailTemplateForm";
import ProposalTicketTemplate from "./proposal-ticket";
import ProposalResubmissionTemplate from "./proposal-resubmission";
import ProposalReviewerTemplate from "./proposal-reviewer";
import ProposalVerifyTemplate from "./proposal-verify";
import ProposalUserShortlistTemplate from "./proposal-user-shortlist";
import BetaFeature from "BetaFeature";

const templateList = [
  {
    key: "welcome_template",
    name: LocaleStrings.setting_email_template_tab1,
    trigger: LocaleStrings.setting_email_template_trigger1,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "welcome_waitlist_template",
    name: LocaleStrings.setting_email_template_tab18,
    trigger: LocaleStrings.setting_email_template_trigger18,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "waitlist_confirmed_template",
    name: LocaleStrings.setting_email_template_tab19,
    trigger: LocaleStrings.setting_email_template_trigger19,
    developmenttype: "eventify",
    isvisiable: true,
  },

  {
    key: "purchase_template",
    name: LocaleStrings.setting_email_template_tab2,
    trigger: LocaleStrings.setting_email_template_trigger2,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "purchase_template_offline",
    name: LocaleStrings.setting_email_template_tab6,
    trigger: LocaleStrings.setting_email_template_trigger6,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "ticket_template",
    name: LocaleStrings.setting_email_template_tab3,
    trigger: LocaleStrings.setting_email_template_trigger3,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "open_reg_template",
    name: LocaleStrings.setting_email_template_tab4,
    trigger: LocaleStrings.setting_email_template_trigger4,
    developmenttype: "eventify",
    isvisiable: false,
  },
  {
    key: "pushemail_template",
    name: LocaleStrings.setting_email_template_tab12,
    trigger: LocaleStrings.setting_email_template_trigger12,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "proposalticket_template",
    name: LocaleStrings.setting_email_template_tab13,
    trigger: LocaleStrings.setting_email_template_trigger13,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "proposalresubmission_template",
    name: LocaleStrings.setting_email_template_tab14,
    trigger: LocaleStrings.setting_email_template_trigger14,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "reviewer_template",
    name: LocaleStrings.setting_email_template_tab15,
    trigger: LocaleStrings.setting_email_template_trigger15,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "proposalverify_template",
    name: LocaleStrings.setting_email_template_tab16,
    trigger: LocaleStrings.setting_email_template_trigger16,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "proposaluser_shortlist_template",
    name: LocaleStrings.setting_email_template_tab17,
    trigger: LocaleStrings.setting_email_template_trigger17,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "support_reply_template",
    name: LocaleStrings.setting_email_template_tab20,
    trigger: LocaleStrings.setting_email_template_trigger20,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "user_scan_export_template",
    name: LocaleStrings.setting_email_template_tab21,
    trigger: LocaleStrings.setting_email_template_trigger21,
    developmenttype: "eventify",
    isvisiable: true,
  },
  {
    key: "user_registration_template",
    name: LocaleStrings.setting_email_template_tab7,
    trigger: LocaleStrings.setting_email_template_trigger7,
    developmenttype: "kochify",
    isvisiable: true,
  },
  {
    key: "course_purchase_template",
    name: LocaleStrings.setting_email_template_tab8,
    trigger: LocaleStrings.setting_email_template_trigger8,
    developmenttype: "kochify",
    isvisiable: true,
  },
  {
    key: "session_purchase_template",
    name: LocaleStrings.setting_email_template_tab9,
    trigger: LocaleStrings.setting_email_template_trigger9,
    developmenttype: "kochify",
    isvisiable: true,
  },
  {
    key: "subscription_purchase_template",
    name: LocaleStrings.setting_email_template_tab10,
    trigger: LocaleStrings.setting_email_template_trigger10,
    developmenttype: "kochify",
    isvisiable: true,
  },
  {
    key: "reset_password_template",
    name: LocaleStrings.setting_email_template_tab11,
    trigger: LocaleStrings.setting_email_template_trigger11,
    developmenttype: "kochify",
    isvisiable: true,
  },
];

class EmailTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateModal: { show: false },
      smtpModal: { show: false },
      testemailModal: { show: false },
    };
  }

  componentDidMount() {
    // this.props.fetchTemplate(this.props.session);
    this.props.fetchFeature(this.props.session);
  }

  openModal = (obj) => {
    this.setState({ templateModal: { show: true, selected: obj } });
  };

  closeModal = () => {
    this.setState({ templateModal: { show: false } });
  };

  openSMTPModal = () => {
    this.setState({ smtpModal: { show: true } });
  };

  closeSMTPModal = () => {
    this.setState({ smtpModal: { show: false } });
  };

  openTestEmailModal = () => {
    this.setState({ testemailModal: { show: true } });
  };

  closeTestEmailModal = () => {
    this.setState({ testemailModal: { show: false } });
  };

  renderList = () => {
    let { totalAppModules } = this.props;
    let proposalMenu = [{ isenabled: false }];
    if (totalAppModules && totalAppModules.length > 0) {
      proposalMenu = _.filter(totalAppModules, (obj) => {
        return obj.bsClass === "proposal";
      });
    }
    // console.log("proposalMenu :- ", proposalMenu);

    let displayList = _.filter(templateList, (obj) => {
      return (
        obj.developmenttype === DEVELOPMENT_TYPE && obj.isvisiable === true
      );
    });

    if (proposalMenu[0].isenabled == false) {
      displayList = _.filter(displayList, (obj) => {
        return (
          obj.key !== "proposalticket_template" &&
          obj.key !== "proposalresubmission_template" &&
          obj.key !== "reviewer_template" &&
          obj.key !== "proposalverify_template" &&
          obj.key !== "proposaluser_shortlist_template"
        );
      });
    }
    // console.log("displayList :- ", displayList);

    return _.map(displayList, (item, index) => {
      return (
        <tr key={`template_key_${index}`}>
          <td className="">
            <div>{item.name}</div>
          </td>
          <td className="">
            <div>{item.trigger}</div>
          </td>
          <td className="">
            <div className="action-button" style={{ marginLeft: 5 }}>
              <button
                className="btn btn-custom-table-white"
                onClick={() => this.openModal(item)}>
                {LocaleStrings.setting_email_template_text_edit_with_gjs}
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  render() {
    let { deviceSize } = this.props;
    let { templateModal, smtpModal, testemailModal } = this.state;

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <div className="custom-text3-primary-medium">
              {LocaleStrings.setting_email_template_heading}
            </div>
          </div>

          <ul className="header-buttons">
            <li>
              <span className="pe-1">
                <BetaFeature />
              </span>
              <button
                type="button"
                className="btn btn-custom-blue"
                onClick={() => this.openSMTPModal()}>
                {LocaleStrings.template_setting_form_label_smtp_type}
              </button>
            </li>
          </ul>
        </div>
        <div className="clearfix" />

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>{LocaleStrings.setting_email_template_th_name}</th>
                  <th>{LocaleStrings.setting_email_template_th_trigger}</th>
                  <th>{LocaleStrings.setting_email_template_th_acion}</th>
                </tr>
              </thead>
              <tbody className="tbody-background">{this.renderList()}</tbody>
            </table>
          </div>

          {/* Email template modal */}
          {templateModal.show === true ? (
            <>
              <Modal
                show={templateModal.show === true ? true : false}
                onHide={this.closeModal}
                dialogClassName="modal-xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                enforceFocus={false}
                animation={true}>
                <Modal.Header>
                  <Modal.Title>
                    <div className="title-modal">
                      {LocaleStrings.setting_email_template_update_modal_title}
                    </div>
                  </Modal.Title>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={this.closeModal}>
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                    />
                  </button>
                </Modal.Header>
                <Modal.Body className="scrollable-modal p-0">
                  {templateModal.selected ? (
                    <div>
                      <Row className="m-0">
                        <Col lg={9} md={8} className="pl-20">
                          {templateModal.selected.key === "welcome_template" ? (
                            <WelcomeTemplateForm
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "welcome_waitlist_template" ? (
                            <WelcomeWaitlistTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "waitlist_confirmed_template" ? (
                            <UserWaitlistConfirmedTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "purchase_template" ? (
                            <PurchaseTemplateForm
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "purchase_template_offline" ? (
                            <PurchaseTemplateOfflineForm
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "ticket_template" ? (
                            <TicketTemplateForm
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "open_reg_template" ? (
                            <OpenRegTicketTemplateForm
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "pushemail_template" ? (
                            <PushEmailtemplateForm
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "proposalticket_template" ? (
                            <ProposalTicketTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "proposalresubmission_template" ? (
                            <ProposalResubmissionTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "reviewer_template" ? (
                            <ProposalReviewerTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "proposalverify_template" ? (
                            <ProposalVerifyTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "proposaluser_shortlist_template" ? (
                            <ProposalUserShortlistTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "support_reply_template" ? (
                            <SupportReplyTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "user_scan_export_template" ? (
                            <UserScanExportTemplate
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "user_registration_template" ? (
                            <UserRegistration
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "course_purchase_template" ? (
                            <CourseOrder type={templateModal.selected.key} />
                          ) : templateModal.selected.key ===
                            "session_purchase_template" ? (
                            <SessionOrder type={templateModal.selected.key} />
                          ) : templateModal.selected.key ===
                            "subscription_purchase_template" ? (
                            <SubscriptionOrder
                              type={templateModal.selected.key}
                            />
                          ) : templateModal.selected.key ===
                            "reset_password_template" ? (
                            <ResetPassword type={templateModal.selected.key} />
                          ) : (
                            "-"
                          )}
                        </Col>
                        <Col lg={3} md={4} className="bg-white pr-20">
                          <div className="email-template-info-container mt-3">
                            <div className="content-title">
                              <img
                                style={{ width: 14, height: 14 }}
                                src="../../style/images/cheklisticons/info-theme.svg"
                                alt="templateinfo"
                              />
                              <span className="custom-text1-theme-medium">
                                {LocaleStrings.notes}
                              </span>
                            </div>
                            <ul className="content-body">
                              <li className="custom-text1-primary-normal">
                                {templateModal.selected.key ===
                                "welcome_template"
                                  ? LocaleStrings.setting_email_template_information1
                                  : templateModal.selected.key ===
                                    "welcome_waitlist_template"
                                  ? LocaleStrings.setting_email_template_information18
                                  : templateModal.selected.key ===
                                    "waitlist_confirmed_template"
                                  ? LocaleStrings.setting_email_template_information19
                                  : templateModal.selected.key ===
                                    "purchase_template"
                                  ? LocaleStrings.setting_email_template_information2
                                  : templateModal.selected.key ===
                                    "purchase_template_offline"
                                  ? LocaleStrings.setting_email_template_information6
                                  : templateModal.selected.key ===
                                    "ticket_template"
                                  ? LocaleStrings.setting_email_template_information3
                                  : templateModal.selected.key ===
                                    "open_reg_template"
                                  ? LocaleStrings.setting_email_template_information4
                                  : templateModal.selected.key ===
                                    "pushemail_template"
                                  ? LocaleStrings.setting_email_template_information12
                                  : templateModal.selected.key ===
                                    "proposalticket_template"
                                  ? LocaleStrings.setting_email_template_information13
                                  : templateModal.selected.key ===
                                    "proposalresubmission_template"
                                  ? LocaleStrings.setting_email_template_information14
                                  : templateModal.selected.key ===
                                    "reviewer_template"
                                  ? LocaleStrings.setting_email_template_information15
                                  : templateModal.selected.key ===
                                    "proposalverify_template"
                                  ? LocaleStrings.setting_email_template_information16
                                  : templateModal.selected.key ===
                                    "proposaluser_shortlist_template"
                                  ? LocaleStrings.setting_email_template_information17
                                  : templateModal.selected.key ===
                                    "support_reply_template"
                                  ? LocaleStrings.setting_email_template_information20
                                  : templateModal.selected.key ===
                                    "user_scan_export_template"
                                  ? LocaleStrings.setting_email_template_information21
                                  : templateModal.selected.key ===
                                    "user_registration_template"
                                  ? LocaleStrings.setting_email_template_information7
                                  : templateModal.selected.key ===
                                    "course_purchase_template"
                                  ? LocaleStrings.setting_email_template_information8
                                  : templateModal.selected.key ===
                                    "session_purchase_template"
                                  ? LocaleStrings.setting_email_template_information9
                                  : templateModal.selected.key ===
                                    "subscription_purchase_template"
                                  ? LocaleStrings.setting_email_template_information10
                                  : templateModal.selected.key ===
                                    "reset_password_template"
                                  ? LocaleStrings.setting_email_template_information11
                                  : "-"}
                              </li>
                            </ul>
                          </div>
                          <div className="email-template-warning-container mt-3">
                            <div className="content-title">
                              <img
                                src="../../style/images/cheklisticons/warning.svg"
                                alt="templateinfo"
                              />
                              <span
                                className="custom-text1-theme-medium"
                                style={{ color: "#D98300" }}>
                                {LocaleStrings.please_note}
                              </span>
                            </div>
                            <ul className="content-body">
                              <li className="custom-text1-primary-normal">
                                {LocaleStrings.setting_email_template_note1}
                              </li>
                              <li className="custom-text1-primary-normal">
                                {LocaleStrings.setting_email_template_note2}
                              </li>
                              <li className="custom-text1-primary-normal">
                                {LocaleStrings.setting_email_template_note4}
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <div className="flex">
                    {templateModal.selected.key == "welcome_template" ? (
                      <button
                        onClick={this.openTestEmailModal}
                        className="btn btn-primary"
                        type="button">
                        {LocaleStrings.setting_email_template_btn_testemail}
                      </button>
                    ) : (
                      ""
                    )}

                    <button
                      onClick={this.closeModal}
                      className="btn btn-custom-white  ml-2"
                      type="button">
                      {LocaleStrings.button_close}
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </>
          ) : (
            ""
          )}

          {/* SMTP setting modal */}
          {testemailModal.show === true ? (
            <>
              <TestEmail
                type="test_email"
                testemailModal={testemailModal}
                closeTestEmailModal={this.closeTestEmailModal}
              />
            </>
          ) : (
            ""
          )}
          {/* SMTP setting modal */}
          {smtpModal.show === true ? (
            <>
              <SMTP
                type="smtp_setting"
                smtpModal={smtpModal}
                closeSMTPModal={this.closeSMTPModal}
              />
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    totalAppModules: state.totalAppModules,
  };
}
export default connect(mapStateToProps, { fetchTemplate, fetchFeature })(
  EmailTemplate
);
